/**
 * Returns a new Date object by adding a specified number of days to a given start date.
 * Adds calendar days, so the local time is kept across daylight saving changes.
 *
 * @param startDate - The starting Date object.
 * @param daysToAdd - The number of days to add.
 * @returns A new Date object with the days added.
 */

export const getRangeEndDate = (startDate: Date, daysToAdd: number) => {
  const endDate = new Date(startDate);

  // Number() as untyped callers may pass the duration from the url as a string
  endDate.setDate(endDate.getDate() + Number(daysToAdd));

  return endDate;
};
